<template>
  <div :class="className"></div>
</template>

<script>
export default {
    name: "Divider",
    props: {
        color: {
            type: String,
            default: "primary"
        }, // "primary" | "success" | "warning" | "danger" | "dark" | "blue"
    },
    data() {
        return {
            className: {
                "divider": true,
                [`divider--${this.color}`]: true
            }
        }
    }
}
</script>

<style lang="scss" scope>
    $colors: (
        "primary": var(--vs-hex-primary),
        "success": var(--vs-hex-success),
        "warning": var(--vs-hex-warning),
        "danger": var(--vs-hex-danger),
        "dark": var(--vs-hex-dark),
        "blue": var(--vs-hex-blue),
        "hyperlead": var(--vs-hex-hyperlead)
    );

    .divider {
        width: 100%;
        height: 1px;
        margin: 1rem 0;
        opacity: 0.4;

        @each $name, $color in $colors {
            &--#{$name} {
                background-color: $color;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Divider/Divider.vue